export function toLowerCase(str) {
    return String(str).toLowerCase();
}

export function prefixChar(str, char, digits) {
    return String(str).padStart(digits, char);
}

export function appendQueryStr2Str(str, queryString) {
    str = String(str);
    if (!queryString) {
        return str;
    } else if (str.indexOf('?') > -1) {
        return `${str}&${queryString}`;
    } else {
        return `${str}?${queryString}`;
    }
}
